<p-overlayPanel #infoPanel styleClass="info-overlay">
  <div class="info-overlay-content">{{ infoOverlayText }}</div>
</p-overlayPanel>

<div class="vjd-page">
  <!-- ============================ BREADCRUMB ============================ -->
  <nav class="vjd-crumbs" aria-label="Breadcrumb">
    <button
      type="button"
      class="back-btn"
      (click)="goBack()"
      pTooltip="Back"
      tooltipPosition="top"
      aria-label="Go back"
    >
      <i class="pi pi-arrow-left"></i>
    </button>
    <span class="vjd-crumb-current">
      {{ jobDetails?.job_title || "Job Details" }}
      <ng-container *ngIf="jobReference">({{ jobReference }})</ng-container>
    </span>
  </nav>

  <!-- ========================== JOB HEADER CARD ========================== -->
  <section class="vjd-job-card tour-job-card" *ngIf="jobDetails">
    <header class="vjd-job-head">
      <div class="vjd-job-title-row">
        <h1 class="tour-job-title">{{ jobDetails.job_title }}</h1>

        <span
          class="vjd-pill tour-job-status"
          [ngClass]="{
            'tone-success': jobDetails?.status_display?.toLowerCase() === 'open',
            'tone-danger': jobDetails?.status_display?.toLowerCase() === 'closed',
            'tone-warning': jobDetails?.status_display?.toLowerCase() === 'on_hold'
          }"
        >
          <i class="pi pi-circle-fill"></i>
          {{ jobDetails?.status_display?.replace("_", " ") || "Approved" }}
          <button
            type="button"
            class="vjd-info-btn"
            (click)="showInfo($event, 'Current hiring status of this job', infoPanel)"
            aria-label="More info"
          >
            <i class="pi pi-info-circle"></i>
          </button>
        </span>

        <span class="vjd-ref" *ngIf="jobReference">#{{ jobReference }}</span>
      </div>

      <ul class="vjd-meta">
        <li *ngIf="jobDetails.min_yoe !== null && jobDetails.min_yoe !== undefined">
          <i class="pi pi-briefcase"></i>
          {{ jobDetails.min_yoe }}-{{ jobDetails.max_yoe }} Years Exp
        </li>
        <li *ngIf="jobDetails.number_of_vacancy">
          <i class="pi pi-users"></i>
          {{ jobDetails.number_of_vacancy }} Positions Open
        </li>
        <li *ngIf="jobDetails.location_names?.[0]">
          <i class="pi pi-map-marker"></i>
          {{ jobDetails.location_names[0] }}
        </li>
        <li *ngIf="jobPostedOn">
          <i class="pi pi-clock"></i>
          Posted {{ jobPostedOn | date: "mediumDate" }}
        </li>
        <li *ngIf="jobDepartment">
          <i class="pi pi-sitemap"></i>
          {{ jobDepartment }}
        </li>
      </ul>
    </header>

    <!-- ------------------------- SUMMARY CARDS ------------------------- -->
    <div class="vjd-summary-grid">
      <div class="vjd-summary">
        <span class="vjd-summary-icon tone-indigo"><i class="pi pi-briefcase"></i></span>
        <div class="vjd-summary-text">
          <span class="vjd-summary-label">Employment Type</span>
          <strong>{{ jobDetails.employment_type_name || "—" }}</strong>
          <small *ngIf="jobDetails.work_mode">{{ jobDetails.work_mode }}</small>
        </div>
      </div>

      <div class="vjd-summary">
        <span class="vjd-summary-icon tone-green"><i class="pi pi-indian-rupee"></i></span>
        <div class="vjd-summary-text">
          <span class="vjd-summary-label">Annual Budget</span>
          <strong>₹ {{ jobDetails.budget }}</strong>
          <small>INR / annum</small>
        </div>
      </div>

      <div class="vjd-summary">
        <span class="vjd-summary-icon tone-violet"><i class="pi pi-building"></i></span>
        <div class="vjd-summary-text">
          <span class="vjd-summary-label">Hiring Entity</span>
          <strong>{{ jobDetails.org_name || "—" }}</strong>
          <small *ngIf="jobDepartment">{{ jobDepartment }}</small>
        </div>
      </div>

      <div class="vjd-summary">
        <span class="vjd-summary-icon tone-rose"><i class="pi pi-map-marker"></i></span>
        <div class="vjd-summary-text">
          <span class="vjd-summary-label">Target Locations</span>
          <strong>{{ jobDetails.location_names?.join(", ") || "—" }}</strong>
          <!-- <small *ngIf="jobDetails.work_mode">{{ jobDetails.work_mode }}</small> -->
        </div>
      </div>
    </div>

    <!-- ---------------------- DESCRIPTION + SKILLS ---------------------- -->
    <div class="vjd-detail-grid">
      <div class="vjd-detail">
        <h3><i class="pi pi-file"></i> Job Description &amp; Scope</h3>
        <p class="vjd-desc" [class.is-clamped]="!descriptionExpanded">
          {{ jobDetails.job_description }}
        </p>
        <button
          type="button"
          class="vjd-text-btn"
          *ngIf="jobDetails.job_description?.length > 320"
          (click)="descriptionExpanded = !descriptionExpanded"
        >
          {{ descriptionExpanded ? "Show less" : "Show more" }}
        </button>
      </div>

      <div class="vjd-detail">
        <h3><i class="pi pi-verified"></i> Required Skills &amp; Stack</h3>

        <ul class="vjd-skills" *ngIf="jobDetails.required_skills_names?.length; else noSkills">
          <li *ngFor="let skill of jobDetails.required_skills_names">
            <i class="pi pi-circle-fill"></i>
            {{ skill }}
          </li>
        </ul>

        <ng-template #noSkills>
          <p class="vjd-empty-inline">No skills listed for this job.</p>
        </ng-template>
      </div>
    </div>
  </section>

  <!-- =========================== ACTION TOOLBAR =========================== -->
  <div class="vjd-actions">
    <!-- Bulk Upload CVs Action (Recruiter). The free-trial tag is glued
         to the button (one visual unit) rather than a separate floating
         pill, so it reads unambiguously as "this action, free" — see
         organization_plan / OrgPlanService. -->
    <div class="trial-btn-group" *ngIf="isRecruiter">
      <button
        type="button"
        class="vjd-btn solid tour-upload-cv"
        [class.has-trial-tag]="isFreeTierOrg"
        (click)="openUploadDialog()"
        pTooltip="Bulk upload single or multiple CVs to this job"
        tooltipPosition="top"
      >
        <i class="pi pi-upload"></i>
        <span>Bulk Upload CVs</span>
      </button>

      <span
        class="trial-tag"
        *ngIf="isFreeTierOrg"
        pTooltip="Your organization is on a free trial — this action won't use wallet coins"
        tooltipPosition="top"
      >
        <i class="pi pi-gift"></i> Free
      </span>
    </div>

    <!-- Rank CV Action (Non-Recruiter) — same glued-tag treatment. -->
    <div class="trial-btn-group" *ngIf="!isRecruiter">
      <button
        type="button"
        class="vjd-btn solid tour-rank-cv"
        [class.has-trial-tag]="isFreeTierOrg"
        (click)="rankCVs()"
        [disabled]="rankingLoading"
        pTooltip="Score and rank all attached resumes against this job's requirements"
        tooltipPosition="top"
      >
        <i [class]="rankingLoading ? 'pi pi-spin pi-spinner' : 'pi pi-chart-line'"></i>
        <span>{{ rankingLoading ? "Ranking..." : "Rank CV" }}</span>
      </button>

      <span
        class="trial-tag"
        *ngIf="isFreeTierOrg"
        pTooltip="Your organization is on a free trial — this action won't use wallet coins"
        tooltipPosition="top"
      >
        <i class="pi pi-gift"></i> Free
      </span>
    </div>

    <!-- Share Link Action -->
    <div class="vjd-share">
      <button
        type="button"
        class="vjd-btn ghost"
        [disabled]="isGeneratingLink"
        (click)="quickCopyExternalLink(jobDetails)"
      >
        <i [class]="isGeneratingLink ? 'pi pi-spin pi-spinner' : 'pi pi-share-alt'"></i>
        <span>{{ isGeneratingLink ? "Copying..." : "Share Link" }}</span>
      </button>
      <small>Collect candidates via direct link</small>
    </div>
  </div>

  <!-- ====================== MAIN CONTAINER WITH TABS ====================== -->
  <p-tabView
    styleClass="custom-job-details-tabs vjd-tabs"
    [(activeIndex)]="activeTabIndex"
    (onChange)="onTabChange($event)"
  >
    <!-- ========================================== -->
    <!-- TAB 1: YOUR EXISTING CANDIDATES CODE       -->
    <!-- ========================================== -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <span>Applied Candidates</span>
        <span class="vjd-tab-count">{{ filteredCandidates.length }}</span>
      </ng-template>

      <!-- Walk-in CVs being attached — tells the user where they'll land -->
      <div class="vjd-attach-banner is-running" *ngIf="attachState === 'running'">
        <i class="pi pi-spin pi-spinner"></i>
        <div class="vjd-attach-text">
          <strong>Adding {{ attachTotal }} walk-in CV{{ attachTotal === 1 ? "" : "s" }} to this job…</strong>
          <span>
            {{ attachProcessed }} of {{ attachTotal }} processed. New candidates will show up in this list
            automatically when they're ready.
          </span>
        </div>
      </div>
      <div class="vjd-attach-banner is-done" *ngIf="attachState === 'done' && attachDone > 0">
        <i class="pi pi-check-circle"></i>
        <div class="vjd-attach-text">
          <strong>{{ attachDone }} walk-in CV{{ attachDone === 1 ? "" : "s" }} added to Applied Candidates.</strong>
          <span *ngIf="attachFailed">{{ attachFailed }} could not be processed — see the Walk-in CV Pool tab.</span>
        </div>
        <button type="button" class="vjd-attach-close" (click)="dismissAttachBanner()" aria-label="Dismiss">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <!-- Failed CV uploads -->
      <div class="vjd-failed-banner" *ngIf="failedCvCount > 0" role="status">
        <span class="vjd-failed-banner__icon"><i class="pi pi-exclamation-triangle"></i></span>
        <div class="vjd-failed-banner__text">
          <strong>{{ failedCvCount }} CV{{ failedCvCount === 1 ? '' : 's' }} failed to upload</strong>
          <span>Click <b>Failed</b> in the Status column to see why and how to fix it.</span>
        </div>
        <button type="button" class="vjd-failed-banner__btn" (click)="toggleFailedOnly()">
          <i class="pi" [ngClass]="showFailedOnly ? 'pi-list' : 'pi-filter'"></i>
          {{ showFailedOnly ? 'Show all candidates' : 'Show failed only' }}
        </button>
      </div>

      <!-- TABLE CARD -->
      <div class="vjd-table-card tour-candidate-table">
        <!-- SEARCH + FILTERS -->
        <div class="vjd-table-toolbar">
          <span class="vjd-search tour-search-candidate">
            <i class="pi pi-search"></i>
            <input
              type="text"
              placeholder="Search candidate name, email, skill..."
              [(ngModel)]="searchText"
              (input)="filterCandidates()"
              aria-label="Search candidates"
            />
          </span>

          <div class="vjd-filters">
            <span class="vjd-filter-label">Filter by:</span>

            <p-dropdown
              [options]="approvalFilterOptions"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [(ngModel)]="approvalFilter"
              (onChange)="filterCandidates()"
              placeholder="Approval"
              styleClass="vjd-filter-dd"
            ></p-dropdown>

            <p-dropdown
              [options]="stageFilterOptions"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [(ngModel)]="stageFilter"
              (onChange)="filterCandidates()"
              placeholder="Stage"
              styleClass="vjd-filter-dd"
            ></p-dropdown>
          </div>
        </div>

        <div class="selection-toolbar vjd-selection" *ngIf="selectedCandidatesCount > 0">
          <div class="selection-info">
            <span class="selection-count">{{ selectedCandidatesCount }}</span>
            <span>candidate{{ selectedCandidatesCount > 1 ? "s" : "" }} selected</span>
          </div>

          <div class="selection-actions">
            <button class="btn-ghost" (click)="clearSelection()">
              <i class="pi pi-times"></i>
              Clear
            </button>

            <!-- Recruiter: send exam invite -->
            <button
              *ngIf="isRecruiter"
              class="btn-notify"
              [disabled]="sendingExamInvite"
              (click)="sendExamInvite()"
            >
              <i class="pi" [ngClass]="sendingExamInvite ? 'pi-spin pi-spinner' : 'pi-envelope'"></i>
              {{ sendingExamInvite ? "Sending..." : "Send Exam Invite" }}
            </button>

            <!-- Non-recruiter: notify recruiter -->
            <button
              *ngIf="!isRecruiter"
              class="btn-notify"
              [disabled]="notifyingRecruiter"
              (click)="notifyRecruiter()"
            >
              <i class="pi" [ngClass]="notifyingRecruiter ? 'pi-spin pi-spinner' : 'pi-send'"></i>
              {{ notifyingRecruiter ? "Sending..." : "Notify Recruiter" }}
            </button>
          </div>
        </div>

        <div class="vjd-table-wrap" *ngIf="filteredCandidates?.length; else noCandidates">
          <table class="vjd-table">
            <thead>
              <tr>
                <th class="vjd-col-check select-col tour-candidate-selection">
                  <span
                    class="checkbox-wrapper"
                    pTooltip="Select all approved candidates"
                    tooltipPosition="top"
                  >
                    <input
                      type="checkbox"
                      class="candidate-checkbox"
                      [checked]="isAllApprovedSelected"
                      [disabled]="!approvedCandidates.length"
                      (change)="toggleSelectAllApproved()"
                    />
                  </span>
                </th>
                <th class="vjd-col-num">#</th>
                <th *ngIf="isRanked" class="vjd-col-rank">Rank</th>
                <th class="vjd-col-cand">Candidate</th>
                <th class="vjd-col-contact">Contact Details</th>

                <th *ngIf="isRanked" class="vjd-col-score">
                  Score
                  <button
                    type="button"
                    class="vjd-info-btn"
                    (click)="showInfo($event, 'How closely this resume matches the job requirements', infoPanel)"
                    aria-label="More info"
                  >
                    <i class="pi pi-info-circle"></i>
                  </button>
                </th>
                <th *ngIf="isRanked" class="vjd-col-rankdet">Ranking Details</th>

                <th class="vjd-col-status" *ngIf="!isRanked">
                  Status
                  <button
                    type="button"
                    class="vjd-info-btn"
                    (click)="showInfo($event, 'Shows the real-time CV processing status', infoPanel)"
                    aria-label="More info"
                  >
                    <i class="pi pi-info-circle"></i>
                  </button>
                </th>

                <th class="vjd-col-approval">
                  Approval
                  <button
                    type="button"
                    class="vjd-info-btn"
                    (click)="showInfo($event, 'Whether this candidate has been approved to proceed', infoPanel)"
                    aria-label="More info"
                  >
                    <i class="pi pi-info-circle"></i>
                  </button>
                </th>

                <th class="vjd-col-invite">
                  Invite
                  <button
                    type="button"
                    class="vjd-info-btn"
                    (click)="showInfo($event, 'Whether the candidate has been sent an assessment link', infoPanel)"
                    aria-label="More info"
                  >
                    <i class="pi pi-info-circle"></i>
                  </button>
                </th>

                <th class="vjd-col-exam">
                  Exam Status
                  <button
                    type="button"
                    class="vjd-info-btn"
                    (click)="showInfo($event, 'Whether the candidate has attempted any exam or round, and the outcome', infoPanel)"
                    aria-label="More info"
                  >
                    <i class="pi pi-info-circle"></i>
                  </button>
                </th>

                <th class="vjd-col-decision">
                  Recruitment Decision
                  <button
                    type="button"
                    class="vjd-info-btn"
                    (click)="showInfo($event, 'Where this candidate currently stands in your hiring pipeline', infoPanel)"
                    aria-label="More info"
                  >
                    <i class="pi pi-info-circle"></i>
                  </button>
                </th>

                <!-- Post-exam status now lives here as a visible column rather
                     than being buried in the row's kebab menu. -->
                <th class="vjd-col-onboard" *ngIf="isRecruiter">
                  Manage Onboarding
                  <button
                    type="button"
                    class="vjd-info-btn"
                    (click)="showInfo($event, 'Record interview outcome, offer and onboarding details for this candidate', infoPanel)"
                    aria-label="More info"
                  >
                    <i class="pi pi-info-circle"></i>
                  </button>
                </th>

                <th class="vjd-col-actions">Actions</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let candidate of paginatedCandidates; let i = index">
                <td class="vjd-col-check select-col tour-candidate-selection" data-label="Select">
                  <span
                    class="checkbox-wrapper"
                    pTooltip="{{
                      candidate.approved === true
                        ? 'Select candidate'
                        : 'Only approved candidates can be selected'
                    }}"
                    tooltipPosition="top"
                  >
                    <input
                      type="checkbox"
                      class="candidate-checkbox"
                      [checked]="isCandidateSelected(candidate)"
                      [disabled]="candidate.approved !== true"
                      (change)="toggleCandidateSelection(candidate)"
                    />
                  </span>
                </td>

                <td class="vjd-col-num" data-label="#">{{ first + i + 1 }}</td>

                <td *ngIf="isRanked" class="vjd-col-rank" data-label="Rank">
                  <span class="vjd-rank">#{{ candidate.rank }}</span>
                </td>

                <td class="vjd-col-cand" data-label="Candidate">
                  <span class="vjd-cand">
                    <strong [title]="candidate.name || candidate.fileName || ''">
                      <ng-container *ngIf="candidate.name">{{ candidate.name }}</ng-container>
                      <span class="vjd-file-name" *ngIf="!candidate.name && candidate.fileName">
                        <i class="pi pi-file-pdf"></i> {{ candidate.fileName }}
                      </span>
                      <ng-container *ngIf="!candidate.name && !candidate.fileName">--</ng-container>
                    </strong>
                    <small *ngIf="candidate.appliedOn">Applied {{ candidate.appliedOn | date: "mediumDate" }}</small>
                  </span>
                </td>

                <td class="vjd-col-contact" data-label="Contact Details">
                  <span class="vjd-contact">
                    <span class="vjd-contact-mail" [title]="candidate.email || ''">{{ candidate.email || "--" }}</span>
                    <small>{{ candidate.mobile || "--" }}</small>
                  </span>
                </td>

                <td *ngIf="isRanked" class="vjd-col-score tour-ranking-details" data-label="Score">
                  <div class="score-cell">
                    <span class="vjd-score">{{ candidate.totalScore | number: "1.0-2" }}%</span>
                    <div class="vjd-score-bar">
                      <div class="vjd-score-fill" [style.width.%]="candidate.totalScore"></div>
                    </div>
                  </div>
                </td>

                <td *ngIf="isRanked" class="tour-ranking-details" data-label="Ranking Details">
                  <button
                    class="vjd-icon-btn"
                    pTooltip="View Ranking Details"
                    tooltipPosition="top"
                    (click)="openRankingDetails(candidate)"
                  >
                    <i class="pi pi-eye"></i>
                  </button>
                </td>

                <td class="vjd-col-status" *ngIf="!isRanked" data-label="Status">
                  <button
                    type="button"
                    class="vjd-pill tone-danger vjd-fail-pill"
                    *ngIf="isFailedCv(candidate)"
                    (click)="openFailureDetails(candidate)"
                    [pTooltip]="candidate.failure?.title + ' — click to see why'"
                    tooltipPosition="top"
                    [attr.aria-label]="'Upload failed: ' + candidate.failure?.title + '. Show details'"
                  >
                    <i class="pi pi-times"></i>
                    Failed
                    <i class="pi pi-question-circle vjd-fail-pill__help"></i>
                  </button>
                  <span
                    *ngIf="!isFailedCv(candidate)"
                    class="vjd-pill"
                    [ngClass]="{
                      'tone-warning': candidate.processingStatus == 'pending',
                      'tone-info':
                        candidate.processingStatus == 'processing' ||
                        candidate.processingStatus == 'in_progress',
                      'tone-success':
                        candidate.processingStatus == 'completed' ||
                        candidate.processingStatus == 'done',
                      'tone-danger': candidate.processingStatus == 'failed'
                    }"
                  >
                    <i
                      class="pi"
                      [ngClass]="{
                        'pi-clock': candidate.processingStatus == 'pending',
                        'pi-spin pi-spinner':
                          candidate.processingStatus == 'processing' ||
                          candidate.processingStatus == 'in_progress',
                        'pi-check': candidate.processingStatus == 'completed' ||
                          candidate.processingStatus == 'done',
                        'pi-times': candidate.processingStatus == 'failed'
                      }"
                    ></i>
                    {{ candidate.processingStatus | titlecase }}
                  </span>
                </td>

                <td class="vjd-col-approval" data-label="Approval">
                  <!-- Pending -->
                  <ng-container *ngIf="candidate.approved === null && !isRecruiter">
                    <span class="vjd-approve-actions">
                      <button
                        class="vjd-icon-btn success"
                        pTooltip="Approve Candidate"
                        tooltipPosition="top"
                        (click)="approveRejectCandidate(candidate, true)"
                      >
                        <i class="pi pi-check-circle"></i>
                      </button>

                      <button
                        class="vjd-icon-btn danger"
                        pTooltip="Reject Candidate"
                        tooltipPosition="top"
                        (click)="approveRejectCandidate(candidate, false)"
                      >
                        <i class="pi pi-times-circle"></i>
                      </button>
                    </span>
                  </ng-container>

                  <ng-container *ngIf="candidate.approved === null && isRecruiter">
                    <span class="vjd-pill tone-warning" pTooltip="Pending for Approval" tooltipPosition="top">
                      Pending
                    </span>
                  </ng-container>

                  <!-- Approved -->
                  <span
                    *ngIf="candidate.approved === true"
                    class="vjd-pill tone-success"
                    pTooltip="Candidate Approved"
                    tooltipPosition="top"
                  >
                    Approved
                  </span>

                  <!-- Rejected -->
                  <span
                    *ngIf="candidate.approved === false"
                    class="vjd-pill tone-danger"
                    pTooltip="Candidate Rejected"
                    tooltipPosition="top"
                  >
                    Rejected
                  </span>
                </td>

                <td class="vjd-col-invite" data-label="Invite">
                  <span
                    class="vjd-pill"
                    [ngClass]="candidate.examInviteSent ? 'tone-info-outline' : 'tone-warning-outline'"
                    pTooltip="{{
                      candidate.examInviteSent
                        ? 'Exam invitation has been sent'
                        : 'Exam invitation has not been sent yet'
                    }}"
                    tooltipPosition="top"
                  >
                    {{ candidate.examInviteSent ? "Sent" : "Pending" }}
                  </span>
                </td>

                <td class="vjd-col-exam" data-label="Exam Status">
                  <ng-container *ngIf="getExamStatusMeta(candidate) as examMeta">
                    <button
                      type="button"
                      class="vjd-exam-chip"
                      [ngClass]="examMeta.cls"
                      (click)="openExamRoundDetails(candidate)"
                      pTooltip="View exam & round details"
                      tooltipPosition="top"
                    >
                      <i class="pi" [ngClass]="examMeta.icon"></i>
                      {{ examMeta.label }}
                      <i class="pi pi-chevron-right vjd-exam-chevron"></i>
                    </button>
                  </ng-container>
                </td>

                <td class="vjd-col-decision" data-label="Recruitment Decision">
                  <!-- Three presentations of the SAME recruiterAction value —
                       locked until the candidate is approved, then the
                       dropdown, then a pill the pencil puts back into the
                       dropdown. updateRecruiterAction is the only writer
                       throughout, so the save path never changes. -->
                  <ng-container [ngSwitch]="decisionState(candidate)">
                    <!-- 1. Not approved yet — nothing to decide. -->
                    <span
                      *ngSwitchCase="'locked'"
                      class="vjd-decision-locked"
                      pTooltip="Approve this candidate before recording a decision"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-lock"></i>
                      Requires Approval
                    </span>

                    <!-- 2. Decision recorded — pill plus the edit button. -->
                    <span *ngSwitchCase="'set'" class="vjd-decision">
                      <span
                        class="vjd-decision-pill"
                        [ngClass]="decisionTone(candidate.recruiterAction)"
                      >
                        {{ decisionLabel(candidate.recruiterAction) }}
                      </span>

                      <button
                        type="button"
                        class="vjd-decision-edit"
                        pTooltip="Change recruitment decision"
                        tooltipPosition="top"
                        aria-label="Change recruitment decision"
                        (click)="editingDecisionFor = candidate"
                      >
                        <i class="pi pi-pencil"></i>
                      </button>
                    </span>

                    <!-- 3. Approved and awaiting a decision, or being edited. -->
                    <p-dropdown
                      *ngSwitchDefault
                      [options]="recruiterStatusOptions"
                      optionLabel="label"
                      optionValue="value"
                      appendTo="body"
                      [ngModel]="candidate.recruiterAction"
                      (onChange)="updateRecruiterAction(candidate, $event.value); editingDecisionFor = null"
                      (onHide)="editingDecisionFor = null"
                      placeholder="Select Status"
                      styleClass="vjd-decision-dd"
                      [style]="{ width: '100%', 'min-width': '150px' }"
                    >
                    </p-dropdown>
                  </ng-container>
                </td>

                <!-- Post Exam Status, surfaced here instead of the kebab menu. -->
                <td class="vjd-col-onboard" *ngIf="isRecruiter" data-label="Manage Onboarding">
                  <button
                    type="button"
                    class="vjd-onboard-btn tour-post-exam"
                    [ngClass]="onboardingState(candidate)"
                    [disabled]="onboardingState(candidate) === 'blocked'"
                    (click)="openExamStatusDialog(candidate)"
                    [pTooltip]="onboardingHint(candidate)"
                    tooltipPosition="top"
                  >
                    <i class="pi" [ngClass]="onboardingState(candidate) === 'start' ? 'pi-plus' : 'pi-briefcase'"></i>
                    {{ onboardingLabel(candidate) }}
                  </button>
                </td>

                <td class="vjd-col-actions" data-label="Actions">
                  <button
                    class="vjd-icon-btn kebab-btn tour-view-resume tour-download-resume"
                    pTooltip="Actions"
                    tooltipPosition="top"
                    (click)="openRowActionsMenu($event, candidate, rowMenu)"
                  >
                    <i class="pi pi-ellipsis-v"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Single shared popup menu for every row's kebab button — items
               are rebuilt for the clicked candidate right before it opens
               (see openRowActionsMenu in the component). -->
          <p-menu
            #rowMenu
            [popup]="true"
            [model]="activeRowMenuItems"
            appendTo="body"
            styleClass="row-actions-menu"
          ></p-menu>

          <div class="vjd-pagination">
            <span class="vjd-showing">
              Showing {{ filteredCandidates.length ? first + 1 : 0 }} to
              {{ pageEnd }} of {{ filteredCandidates.length }} candidate entries
            </span>

            <p-paginator
              [rows]="rows"
              [first]="first"
              [totalRecords]="filteredCandidates.length"
              [rowsPerPageOptions]="[5, 10, 20, 50]"
              (onPageChange)="onPageChange($event)"
            >
            </p-paginator>
          </div>
        </div>

        <ng-template #noCandidates>
          <!-- Initial State -->
          <div class="vjd-empty" *ngIf="!isRankingDone">
            <i class="pi pi-file"></i>
            <h3>No Resume Attached</h3>
            <p>No candidate resumes have been attached to this job yet.</p>
          </div>

          <!-- Ranking Done But No Match -->
          <div class="vjd-empty" *ngIf="isRankingDone">
            <i class="pi pi-search"></i>
            <h3>No CV Matched</h3>
            <p>No candidates matched the ranking criteria.</p>
          </div>
        </ng-template>
      </div>
    </p-tabPanel>

    <!-- ========================================== -->
    <!-- TAB 2: DIRECT WALK-IN & EXTERNAL CV POOL   -->
    <!-- ========================================== -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <span>Walk-in CV Pool</span>
        <i
          class="pi pi-spin pi-spinner vjd-tab-spinner"
          *ngIf="attachState === 'running'"
          pTooltip="Attaching CVs…"
          tooltipPosition="top"
        ></i>

        <!-- REAL-TIME VISIBLE BADGE -->
        <span class="vjd-tab-count" *ngIf="pendingWalkinCount > 0">
          {{ pendingWalkinCount }}
        </span>
      </ng-template>

      <div class="vjd-table-card">
        <!-- ATTACH PROGRESS BANNER -->
        <div class="vjd-attach-panel" *ngIf="attachState !== 'idle'" [ngClass]="'is-' + attachState">
          <div class="vjd-attach-head">
            <span class="vjd-attach-icon">
              <i class="pi pi-spin pi-spinner" *ngIf="attachState === 'running'"></i>
              <i class="pi pi-check-circle" *ngIf="attachState === 'done' && attachDone > 0"></i>
              <i class="pi pi-exclamation-triangle" *ngIf="attachState === 'error' || (attachState === 'done' && attachDone === 0)"></i>
            </span>

            <div class="vjd-attach-text">
              <ng-container *ngIf="attachState === 'running'">
                <strong>Attaching {{ attachTotal }} CV{{ attachTotal === 1 ? "" : "s" }} to this job…</strong>
                <span>
                  Reading each resume and creating the candidate account. This can take a minute; you can keep
                  working, and finished candidates will appear in the <b>Applied Candidates</b> tab.
                </span>
              </ng-container>

              <ng-container *ngIf="attachState === 'done'">
                <strong *ngIf="attachDone > 0">
                  Done. {{ attachDone }} CV{{ attachDone === 1 ? "" : "s" }} attached{{ attachFailed ? ", " + attachFailed + " failed" : "" }}.
                </strong>
                <strong *ngIf="attachDone === 0">None of the selected CVs could be attached.</strong>
                <span *ngIf="attachDone > 0">The candidates are now listed in the Applied Candidates tab.</span>
                <span *ngIf="attachFailed">Failed CVs stay in this pool — check the file and try again.</span>
              </ng-container>

              <ng-container *ngIf="attachState === 'error'">
                <strong>Couldn't attach the CVs.</strong>
                <span>{{ attachMessage }}</span>
              </ng-container>
            </div>

            <div class="vjd-attach-actions">
              <button
                type="button"
                class="vjd-btn solid"
                *ngIf="attachState === 'done' && attachDone > 0"
                (click)="viewAppliedCandidates()"
              >
                <i class="pi pi-users"></i>
                <span>View Applied Candidates</span>
              </button>
              <button
                type="button"
                class="vjd-attach-close"
                *ngIf="attachState !== 'running'"
                (click)="dismissAttachBanner()"
                aria-label="Dismiss"
              >
                <i class="pi pi-times"></i>
              </button>
            </div>
          </div>

          <div class="vjd-attach-progress" *ngIf="attachState === 'running'">
            <div class="vjd-attach-bar">
              <span [style.width.%]="batchProgressPercent || (attachProcessed / (attachTotal || 1)) * 100"></span>
            </div>
            <small>{{ attachProcessed }} of {{ attachTotal }} processed</small>
          </div>
        </div>

        <!-- TAB 2 / BATCH DETAILED LIST -->
        <ul class="vjd-batch-list" *ngIf="attachState !== 'idle' && batchStatusData?.cvs?.length">
          <li *ngFor="let item of batchStatusData.cvs">
            <span class="vjd-batch-id">#{{ item.id }}</span>

            <span class="vjd-batch-text">
              <!-- Candidate Name with Fallback -->
              <strong>{{ item.name || "Queued / Extracting details..." }}</strong>
              <!-- Candidate Email with Fallback -->
              <small *ngIf="item.emails">{{ item.emails }}</small>
              <small class="vjd-fail-text" *ngIf="item.processing_status === 'failed'">
                <i class="pi pi-exclamation-circle"></i> {{ failureInfo(item.failure_reason).title }}
              </small>
            </span>

            <!-- Processing Status Badge -->
            <span
              class="vjd-pill"
              [ngClass]="{
                'tone-warning': item.processing_status === 'pending',
                'tone-info':
                  item.processing_status === 'in_progress' ||
                  item.processing_status === 'processing',
                'tone-success':
                  item.processing_status === 'completed' ||
                  item.processing_status === 'done',
                'tone-danger': item.processing_status === 'failed'
              }"
            >
              <i
                class="pi pi-spin pi-spinner"
                *ngIf="
                  item.processing_status === 'pending' ||
                  item.processing_status === 'in_progress'
                "
              ></i>
              {{ item.processing_status || "pending" | titlecase }}
            </span>
          </li>
        </ul>

        <!-- POOL TOOLBAR ACTIONS -->
        <div class="vjd-pool-toolbar">
          <div class="vjd-pool-desc">
            <h3>Unattached Walk-in / External Resumes</h3>
            <p>
              Select candidate CVs to automatically parse, create candidate
              accounts, and attach them to this job post.
            </p>
          </div>

          <div class="vjd-pool-actions">
            <button
              type="button"
              class="vjd-btn ghost icon-only"
              (click)="fetchWalkinCVs()"
              [disabled]="loadingWalkinCVs"
              pTooltip="Refresh List"
              tooltipPosition="top"
            >
              <i class="pi pi-refresh" [class.pi-spin]="loadingWalkinCVs"></i>
            </button>

            <button
              type="button"
              class="vjd-btn solid"
              [disabled]="!selectedWalkinCVs.length || processingCVs || attachState === 'running'"
              (click)="processSelectedCVs()"
            >
              <i class="pi pi-paperclip" *ngIf="!processingCVs && attachState !== 'running'"></i>
              <i class="pi pi-spin pi-spinner" *ngIf="processingCVs || attachState === 'running'"></i>
              <span *ngIf="!processingCVs && attachState !== 'running'">Attach Selected ({{ selectedWalkinCVs.length }})</span>
              <span *ngIf="processingCVs">Sending…</span>
              <span *ngIf="!processingCVs && attachState === 'running'">Attaching…</span>
            </button>
          </div>
        </div>

        <!-- WALK-IN CVS TABLE -->
        <div class="vjd-walkin-wrap">
          <p-table
            [value]="walkinCVList"
            [(selection)]="selectedWalkinCVs"
            dataKey="id"
            [loading]="loadingWalkinCVs"
            styleClass="p-datatable-sm vjd-walkin-table"
          >
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 3rem">
                  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th>File Name</th>
                <th>Status</th>
                <th>Uploaded By</th>
                <th>Upload Date</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-cv>
              <tr>
                <td>
                  <p-tableCheckbox [value]="cv"></p-tableCheckbox>
                </td>
                <td class="vjd-filename">
                  <i class="pi pi-file-pdf"></i>
                  <span [pTooltip]="cv.filename" tooltipPosition="top">{{ cv.filename }}</span>
                </td>
                <td>
                  <span
                    class="vjd-pill"
                    [ngClass]="{
                      'tone-warning': cv.processing_status == 'pending',
                      'tone-info':
                        cv.processing_status == 'processing' ||
                        cv.processing_status == 'in_progress',
                      'tone-indigo-soft': cv.processing_status == 'creating_user',
                      'tone-success':
                        cv.processing_status == 'completed' ||
                        cv.processing_status == 'done',
                      'tone-danger': cv.processing_status == 'failed'
                    }"
                  >
                    <i
                      class="pi"
                      [ngClass]="{
                        'pi-clock': cv.processing_status == 'pending',
                        'pi-spin pi-spinner':
                          cv.processing_status == 'processing' ||
                          cv.processing_status == 'creating_user' ||
                          cv.processing_status == 'in_progress',
                        'pi-check': cv.processing_status == 'completed' ||
                          cv.processing_status == 'done',
                        'pi-times': cv.processing_status == 'failed'
                      }"
                    ></i>
                    {{ cv.processing_status | titlecase }}
                  </span>
                </td>
                <td>
                  <span class="vjd-pill tone-muted">User #{{ cv.uploaded_by }}</span>
                </td>
                <td>{{ cv.uploaded_at | date: "medium" }}</td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5">
                  <div class="vjd-empty">
                    <i class="pi pi-inbox"></i>
                    <p>No pending walk-in CVs found for this job post.</p>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>

<!--onboarding form-->
<p-dialog
  [(visible)]="examDialogVisible"
  (onHide)="onOnboardingDialogHide()"
  [modal]="true"
  [showHeader]="false"
  [responsive]="true"
  [style]="onboardingDialogStyle"
  [breakpoints]="{ '1100px': '96vw' }"
  class="modern-dialog onboarding-status-dialog"
  [ngClass]="'pes-step-' + currentOnboardingStep"
>
  <ng-template pTemplate="content">
    <!-- ------------------------------ title bar ------------------------------ -->
    <div class="pes-titlebar">
      <div class="pes-title-group">
        <h3>Manage Onboarding</h3>

        <!-- Grouped right next to the heading (not floated across the
             titlebar) so it reads as "this dialog, free" — the org isn't
             billed for onboarding while on trial (see organization_plan /
             OrgPlanService). -->
        <span class="trial-tag" *ngIf="isFreeTierOrg">
          <i class="pi pi-gift"></i> Free during trial
        </span>
      </div>

      <button
        class="pes-close"
        type="button"
        (click)="examDialogVisible = false"
        aria-label="Close"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>

    <!-- --------------------------- candidate card --------------------------- -->
    <div class="pes-candidate">
      <span class="pes-candidate-avatar"><i class="pi pi-user"></i></span>

      <div class="pes-candidate-text">
        <strong>{{ selectedCandidate?.name || "Candidate" }}</strong>
        <span class="pes-candidate-meta">
          <span class="pes-role">{{ onboardingRoleLabel }}</span>
          <ng-container *ngIf="onboardingExamSummary">
            <span class="pes-sep">•</span>
            <span class="pes-exam">{{ onboardingExamSummary }}</span>
          </ng-container>
        </span>
      </div>
    </div>

    <!-- ------------------------------- stepper ------------------------------- -->
    <!-- Replaces <p-steps>: same three items and the same
         `currentOnboardingStep` index, drawn as the numbered track in the
         design. Steps already completed stay clickable (that is what
         prevStep() does); steps ahead are not, because moving forward has
         to go through nextStep(), which saves the current step first. -->
    <div class="pes-stepper" role="tablist" aria-label="Onboarding steps">
      <div
        class="pes-step"
        *ngFor="let step of onboardingSteps; let i = index"
        [class.is-active]="currentOnboardingStep === i"
        [class.is-done]="currentOnboardingStep > i"
      >
        <button
          type="button"
          class="pes-step-btn"
          role="tab"
          [attr.aria-selected]="currentOnboardingStep === i"
          [disabled]="i > currentOnboardingStep"
          (click)="goToOnboardingStep(i)"
        >
          <span class="pes-step-dot">
            <i class="pi pi-check" *ngIf="currentOnboardingStep > i"></i>
            <ng-container *ngIf="currentOnboardingStep <= i">{{ i + 1 }}</ng-container>
          </span>
          <span class="pes-step-label">{{ step.label }}</span>
        </button>

        <span class="pes-step-line" *ngIf="i < onboardingSteps.length - 1"></span>
      </div>
    </div>

    <div class="pes-body">
      <form [formGroup]="onboardingForm" class="modern-form">
        <!-- ======================= Step 1: Interview ======================= -->
        <div *ngIf="currentOnboardingStep === 0" class="form-section">
          <div class="form-row">
            <div class="form-field half-width">
              <label for="interview_date">
                Interview Date &amp; Time <span class="pes-req">*</span>
              </label>
              <div class="input-container">
                <p-calendar
                  id="interview_date"
                  formControlName="interview_date"
                  dateFormat="yy-mm-dd"
                  [showIcon]="true"
                  appendTo="body"
                  icon="pi pi-calendar"
                  class="input-field"
                ></p-calendar>
              </div>
              <small class="text-red-500" *ngIf="isInvalid('interview_date')">
                Interview date is required.
              </small>
            </div>

            <div class="form-field half-width">
              <label for="interviewer_name">
                Interviewer Name <span class="pes-req">*</span>
              </label>
              <div class="input-container">
                <div class="icon-container"><i class="pi pi-user"></i></div>
                <input
                  pInputText
                  id="interviewer_name"
                  formControlName="interviewer_name"
                  placeholder="Enter name"
                  class="input-field"
                />
              </div>
              <small class="text-red-500" *ngIf="isInvalid('interviewer_name')">
                Please enter interviewer name.
              </small>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field half-width">
              <label for="interview_result">
                Interview Result <span class="pes-req">*</span>
              </label>
              <div class="input-container">
                <p-dropdown
                  id="interview_result"
                  [options]="interviewResultOptions"
                  formControlName="interview_result"
                  placeholder="Select result"
                  appendTo="body"
                  class="input-field custom-bordered-dropdown"
                ></p-dropdown>
              </div>
              <small class="text-red-500" *ngIf="isInvalid('interview_result')">
                Please select interview result.
              </small>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field full-width">
              <label for="interview_feedback">Comprehensive Interview Feedback</label>
              <div class="input-container">
                <textarea
                  pInputTextarea
                  id="interview_feedback"
                  rows="4"
                  formControlName="interview_feedback"
                  placeholder="Write here……"
                  class="input-field"
                ></textarea>
              </div>
            </div>
          </div>
        </div>

        <!-- ========================= Step 2: Offer ========================= -->
        <div *ngIf="currentOnboardingStep === 1" class="form-section">
          <div class="form-row">
            <div class="form-field half-width">
              <label for="offer_rolled_out_date">
                Offer Date <span class="pes-req">*</span>
              </label>
              <div class="input-container">
                <p-calendar
                  id="offer_rolled_out_date"
                  formControlName="offer_rolled_out_date"
                  dateFormat="yy-mm-dd"
                  [showIcon]="true"
                  appendTo="body"
                  icon="pi pi-calendar"
                  class="input-field"
                ></p-calendar>
              </div>
              <small
                class="text-red-500"
                *ngIf="isInvalid('offer_rolled_out_date')"
              >
                Offer date is required.
              </small>
            </div>

            <div class="form-field half-width">
              <label for="offer_amount">
                Offer Amount (LPA) <span class="pes-req">*</span>
              </label>
              <div class="input-container">
                <div class="icon-container"><i class="pi pi-wallet"></i></div>
                <input
                  pInputText
                  id="offer_amount"
                  formControlName="offer_amount"
                  placeholder="4.5"
                  class="input-field"
                />
              </div>
              <small class="text-red-500" *ngIf="isInvalid('offer_amount')">
                Enter a valid amount (e.g., 4.5).
              </small>
            </div>
          </div>

          <!-- Tentative joining date: design-only, no field behind it yet. -->
          <div class="form-row">
            <div class="form-field half-width pes-preview">
              <label>
                Tentative Joining Date
                <span class="pes-preview-tag">Preview</span>
              </label>
              <div class="input-container pes-inert">
                <div class="icon-container"><i class="pi pi-calendar"></i></div>
                <span class="pes-inert-value">Not tracked yet</span>
              </div>
            </div>
          </div>

          <!-- ======================= OFFER TEMPLATE =======================
               Two options, the same pair as before: the platform's own
               standard letter, and this organisation's uploaded one. The
               summary line shows whichever is selected; Change opens both.

               GET  /user/masters/organizations/{id}/
               POST /user/masters/organizations/{id}/upload-offer-template/ -->

          <div class="pes-template-row is-loading" *ngIf="loadingOrgTemplate">
            <span class="pes-spinner sm"></span>
            <div class="pes-template-text">
              <strong>Checking your offer template…</strong>
            </div>
          </div>

          <div class="pes-template-row" *ngIf="!loadingOrgTemplate">
            <span
              class="pes-template-icon"
              [class.standard]="!usingOrgTemplate"
            >
              <i
                class="pi"
                [ngClass]="usingOrgTemplate ? 'pi-file-pdf' : 'pi-verified'"
              ></i>
            </span>

            <div class="pes-template-text">
              <strong>
                {{ activeTemplateLabel }}
                <span class="pes-template-flag">In use</span>
              </strong>
              <small>{{ activeTemplateHint }}</small>
            </div>

            <div class="pes-template-actions">
              <button
                type="button"
                class="pes-mini-btn"
                *ngIf="canViewActiveTemplate"
                (click)="viewOfferTemplate()"
              >
                <i class="pi pi-external-link"></i>
                View
              </button>

              <button
                type="button"
                class="pes-mini-btn"
                [class.is-open]="templatePickerOpen"
                (click)="templatePickerOpen = !templatePickerOpen"
              >
                Change
                <i class="pi pi-chevron-down"></i>
              </button>
            </div>
          </div>

          <!-- Both options, plus the uploads. -->
          <div class="pes-template-picker" *ngIf="templatePickerOpen">
            <button
              type="button"
              class="pes-choice"
              [class.is-selected]="!usingOrgTemplate"
              (click)="selectTemplate('standard')"
            >
              <span class="pes-radio"></span>
              <span class="pes-choice-text">
                <strong>Standard Offer Template</strong>
                <small>
                  The platform's own letter. Nothing to upload — it is applied
                  when the offer is sent.
                </small>
              </span>
            </button>

            <!-- Organisation template, once one exists. -->
            <button
              type="button"
              class="pes-choice"
              *ngIf="hasOrgTemplate"
              [class.is-selected]="usingOrgTemplate"
              (click)="selectTemplate('organisation')"
            >
              <span class="pes-radio"></span>
              <span class="pes-choice-text">
                <strong>{{ orgTemplateName }}</strong>
                <small>
                  Your organisation's template, used for every candidate.
                </small>
              </span>
            </button>

            <button
              type="button"
              class="pes-choice is-upload"
              [disabled]="uploadingTemplate"
              (click)="offerTemplateInput.click()"
            >
              <span class="pes-choice-icon">
                <i
                  class="pi"
                  [ngClass]="uploadingTemplate ? 'pi-spin pi-spinner' : 'pi-upload'"
                ></i>
              </span>
              <span class="pes-choice-text">
                <strong>
                  {{ hasOrgTemplate ? "Replace your template" : "Upload your own template" }}
                </strong>
                <small>
                  .docx or .pdf, up to 15MB — saved once and reused for every
                  candidate after this.
                </small>
              </span>
            </button>

            <button
              type="button"
              class="pes-choice is-upload"
              (click)="candidateLetterInput.click()"
            >
              <span class="pes-choice-icon"><i class="pi pi-user-edit"></i></span>
              <span class="pes-choice-text">
                <strong>Attach a letter for this candidate only</strong>
                <small>
                  Sent instead of the selected template, just for
                  {{ selectedCandidate?.name || "this candidate" }}.
                </small>
              </span>
            </button>
          </div>

          <!-- The per-candidate override, once attached. -->
          <div class="pes-template-row is-override" *ngIf="candidateLetterFile">
            <span class="pes-template-icon override">
              <i class="pi pi-user-edit"></i>
            </span>

            <div class="pes-template-text">
              <strong>
                {{ candidateLetterFile.name }}
                <span class="pes-template-flag override">This candidate</span>
              </strong>
              <small>Sent instead of {{ activeTemplateLabel }}</small>
            </div>

            <div class="pes-template-actions">
              <button
                type="button"
                class="pes-mini-btn"
                (click)="clearCandidateLetter()"
              >
                <i class="pi pi-times"></i>
                Remove
              </button>
            </div>
          </div>

          <input
            #offerTemplateInput
            type="file"
            accept=".doc,.docx,.pdf"
            class="pes-file-input"
            (change)="onOfferTemplateSelected($event)"
          />

          <input
            #candidateLetterInput
            type="file"
            accept=".doc,.docx,.pdf"
            class="pes-file-input"
            (change)="onCandidateLetterSelected($event)"
          />

          <div class="form-row">
            <div class="form-field full-width">
              <label for="offer_details">
                Offer Details <span class="pes-req">*</span>
              </label>
              <div class="input-container">
                <textarea
                  pInputTextarea
                  id="offer_details"
                  rows="3"
                  formControlName="offer_details"
                  placeholder="Compensation breakdown, probation, notice period…"
                  class="input-field"
                ></textarea>
              </div>
              <small class="text-red-500" *ngIf="isInvalid('offer_details')">
                Offer details are required.
              </small>
            </div>
          </div>

          <!-- Acceptance is NOT recorded here: the offer hasn't been sent yet.
               It is recorded once, on the Review & Send step, after sending. -->
          <div class="pes-flow-note">
            <i class="pi pi-info-circle"></i>
            <div>
              <strong>What happens next</strong>
              <ol>
                <li><b>Next</b> saves these offer details.</li>
                <li>On <b>Review &amp; Send</b>, check the email and click <b>Send Offer</b>.</li>
                <li>When the candidate confirms, tick <b>Candidate accepted the offer</b> there — it saves instantly and unlocks Onboarding.</li>
              </ol>
            </div>
          </div>
        </div>


        <!-- ====================== Step 3: Review & Send ======================
             The candidate never sees "the template" — they see an email
             with a letter attached, so that is what this step previews.
             Both the body and the send come from the backend, so what is
             shown here is what the mailer actually sends. -->
        <div *ngIf="currentOnboardingStep === 2" class="form-section pes-review">
          <!-- preview loading -->
          <div class="pes-preview-loading" *ngIf="loadingPreview">
            <span class="pes-spinner"></span>
            <strong>Building the offer email…</strong>
          </div>

          <!-- preview failed -->
          <div class="pes-warn" *ngIf="!loadingPreview && previewError">
            <i class="pi pi-exclamation-triangle"></i>
            <span>
              {{ previewError }}
              <button type="button" class="pes-inline-link" (click)="retryPreview()">
                Try again
              </button>
            </span>
          </div>

          <!-- the email, exactly as the server composed it -->
          <div class="pes-mail" *ngIf="!loadingPreview && offerPreviewHtml">
            <div class="pes-mail-head">
              <div class="pes-mail-line">
                <span class="pes-mail-label">To</span>
                <span class="pes-mail-value">{{ offerPreviewTo }}</span>
              </div>

              <div class="pes-mail-line">
                <span class="pes-mail-label">Subject</span>
                <span class="pes-mail-value strong">{{ offerPreviewSubject }}</span>
              </div>
            </div>

            <div class="pes-mail-body rich" [innerHTML]="offerPreviewHtml"></div>

            <div class="pes-mail-foot">
              <i class="pi pi-server"></i>
              <span>Composed by the server — this is the exact message that will be sent.</span>
            </div>
          </div>

          <!-- the letter: a chip, not a pane -->
          <div class="pes-attach" *ngIf="!loadingPreview">
            <span class="pes-attach-icon"><i class="pi pi-file-pdf"></i></span>

            <div class="pes-attach-text">
              <strong>{{ outgoingLetterName }}</strong>
              <small>{{ outgoingLetterSource }}</small>
            </div>

            <button
              type="button"
              class="pes-mini-btn solid"
              *ngIf="hasOutgoingLetter"
              (click)="viewOutgoingLetter()"
            >
              <i class="pi pi-external-link"></i>
              View
            </button>
          </div>

          <!-- sent -->
          <div class="pes-sent" *ngIf="offerSent">
            <span class="pes-sent-icon"><i class="pi pi-check"></i></span>
            <div class="pes-sent-text">
              <strong>Offer sent · awaiting the candidate's call</strong>
              <small>
                The email asks {{ selectedCandidate?.name || "the candidate" }} to
                confirm with HR by phone. Tick the box below once that call
                happens — onboarding unlocks then.
              </small>
            </div>
          </div>

          <!-- acceptance: the gate on Step 4 — the ONLY place it is recorded.
               Locked until the offer is sent; ticking it saves immediately. -->
          <div
            class="pes-accept"
            [class.is-accepted]="offerAccepted"
            [class.is-waiting]="!canRecordAcceptance"
            [class.is-locked]="!canRecordAcceptance"
          >
            <p-checkbox
              [binary]="true"
              [ngModel]="offerAccepted"
              [ngModelOptions]="{ standalone: true }"
              (onChange)="onAcceptanceToggle($event.checked)"
              [disabled]="!canRecordAcceptance || savingAcceptance"
              inputId="acceptOffer"
            ></p-checkbox>

            <label for="acceptOffer" class="pes-accept-text">
              <strong>Candidate accepted the offer</strong>
              <small *ngIf="!canRecordAcceptance">
                <i class="pi pi-lock"></i> Send the offer first — then tick this once the
                candidate confirms.
              </small>
              <small *ngIf="canRecordAcceptance && !offerAccepted">
                Tick after the candidate confirms. Saved instantly and unlocks Step 4 (Onboarding).
              </small>
              <small *ngIf="offerAccepted">
                Saved. Onboarding is unlocked — click <b>Continue to Onboarding</b>.
              </small>
            </label>

            <span class="pes-accept-chip is-saving" *ngIf="savingAcceptance">
              <i class="pi pi-spin pi-spinner"></i> Saving
            </span>
            <span class="pes-accept-chip" *ngIf="offerAccepted && !savingAcceptance">Confirmed</span>
          </div>
        </div>

        <!-- ======================= Step 4: Onboarding ======================= -->
        <!-- The notice sits outside the section: `disabled-step` sets
             pointer-events:none, so anything inside it would be inert too. -->
        <div
          class="pes-locked"
          *ngIf="currentOnboardingStep === 3 && !offerAccepted"
        >
          <i class="pi pi-lock"></i>
          <span>
            Waiting on the candidate's acceptance. Go <strong>Back</strong> to
            <strong>Review &amp; Send</strong>, send the offer if you haven't, then tick
            <strong>Candidate accepted the offer</strong> to unlock onboarding.
          </span>
        </div>

        <div
          *ngIf="currentOnboardingStep === 3"
          class="form-section"
          [class.disabled-step]="onboardingLocked"
        >
          <div class="form-row">
            <div class="form-field half-width">
              <label for="onboarding_date">
                Joining / Onboarding Date <span class="pes-req">*</span>
              </label>
              <div class="input-container">
                <p-calendar
                  id="onboarding_date"
                  formControlName="onboarding_date"
                  dateFormat="yy-mm-dd"
                  [showIcon]="true"
                  appendTo="body"
                  icon="pi pi-calendar"
                  class="input-field"
                  [disabled]="docsNotVerified"
                ></p-calendar>
              </div>
              <small
                class="text-red-500"
                *ngIf="!docsNotVerified && isInvalid('onboarding_date')"
              >
                Onboarding date is required.
              </small>
            </div>

            <div class="form-field half-width">
              <label for="onboarding_status">
                Onboarding Status <span class="pes-req">*</span>
              </label>
              <div class="input-container">
                <p-dropdown
                  id="onboarding_status"
                  [options]="onboardingStatusOptions"
                  formControlName="onboarding_status"
                  placeholder="Select status"
                  appendTo="body"
                  class="input-field custom-bordered-dropdown"
                  [disabled]="docsNotVerified"
                ></p-dropdown>
              </div>
              <small
                class="text-red-500"
                *ngIf="!docsNotVerified && isInvalid('onboarding_status')"
              >
                Please select onboarding status.
              </small>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field full-width">
              <label for="additional_info">
                Additional Info &amp; Welcome Instructions
              </label>
              <div class="input-container">
                <textarea
                  pInputTextarea
                  id="additional_info"
                  rows="4"
                  formControlName="additional_info"
                  placeholder="Reporting location, who to meet on day one, what to bring…"
                  class="input-field"
                  [maxlength]="1000"
                  [disabled]="docsNotVerified"
                ></textarea>
              </div>
              <div class="pes-counter">
                <span>Plain text, sent with the onboarding record</span>
                <span>{{ additionalInfoLength }} / 1,000 characters</span>
              </div>
            </div>
          </div>

          <div *ngIf="docsNotVerified" class="docs-warning-banner mt-3">
            <i class="pi pi-info-circle"></i>
            Documents are not verified. Please verify documents before filling
            onboarding details.
          </div>
        </div>
      </form>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="pes-footer">
      <button
        pButton
        type="button"
        label="Back"
        icon="pi pi-arrow-left"
        class="p-button-text pes-btn-back"
        (click)="prevStep()"
        [disabled]="currentOnboardingStep === 0"
      ></button>

      <div class="pes-footer-right">
        <button
          pButton
          type="button"
          label="Cancel"
          class="p-button-text pes-btn-cancel"
          (click)="examDialogVisible = false"
        ></button>

        <!-- Next Button — Interview and Offer steps only. -->
        <button
          *ngIf="currentOnboardingStep < 2"
          pButton
          type="button"
          label="Next"
          icon="pi pi-arrow-right"
          iconPos="right"
          class="pes-btn-next"
          (click)="nextStep()"
        ></button>

        <!-- Review step: send first, then move on. Once sent, the primary
             action becomes Continue so the step can still be left. -->
        <ng-container *ngIf="currentOnboardingStep === 2">
          <button
            *ngIf="!offerSent"
            pButton
            type="button"
            [label]="isSendingOffer ? 'Sending…' : 'Send Offer'"
            [icon]="isSendingOffer ? 'pi pi-spin pi-spinner' : 'pi pi-send'"
            iconPos="right"
            [disabled]="isSendingOffer"
            class="pes-btn-send"
            (click)="sendOffer()"
          ></button>

          <button
            *ngIf="offerSent || offerAccepted"
            pButton
            type="button"
            [label]="offerAccepted ? 'Continue to Onboarding' : 'Continue'"
            icon="pi pi-arrow-right"
            iconPos="right"
            class="pes-btn-next"
            [disabled]="savingAcceptance"
            (click)="nextStep()"
          ></button>
        </ng-container>

        <!-- Submit Button -->
        <button
          *ngIf="currentOnboardingStep === onboardingSteps.length - 1"
          pButton
          type="button"
          [label]="isOnboardingUpdate ? 'Update' : 'Submit'"
          [icon]="isSubmitLoading ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
          [disabled]="isSubmitLoading || onboardingLocked"
          class="pes-btn-submit"
          (click)="submitOnboarding()"
        ></button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<!-- Schedule Manual Interview Dialog -->
<p-dialog
  [(visible)]="manualScheduleDialogVisible"
  [modal]="true"
  [showHeader]="false"
  [responsive]="true"
  [style]="{ width: '92vw', 'max-width': '480px' }"
  class="modern-dialog manual-schedule-dialog"
>
  <ng-template pTemplate="content">
    <div class="tl-banner ms-banner">
      <button
        class="tl-close"
        type="button"
        (click)="closeManualScheduleDialog()"
        aria-label="Close"
      >
        <i class="pi pi-times"></i>
      </button>

      <div class="pes-banner-icon">
        <i class="pi pi-calendar-plus"></i>
      </div>

      <div class="tl-banner-text">
        <span class="tl-eyebrow">
          {{
            isEditingSchedule
              ? "Reschedule Interview"
              : manualScheduleResult
                ? "Interview Details"
                : "Schedule Manual Interview"
          }}
        </span>
        <span class="tl-email">{{
          selectedCandidate?.name || "Candidate"
        }}</span>
      </div>
    </div>

    <div class="pes-body ms-body">
      <!-- Checking for an existing booking -->
      <div class="ms-loading" *ngIf="manualScheduleLoading">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Checking for an existing interview...</span>
      </div>

      <!-- Could not check (network / server error, not a 404) -->
      <p
        class="ms-load-error"
        *ngIf="!manualScheduleLoading && manualScheduleLoadError"
      >
        <i class="pi pi-exclamation-triangle"></i>
        {{ manualScheduleLoadError }}
        <button
          type="button"
          class="ms-link-btn"
          (click)="loadManualSchedule()"
        >
          Retry
        </button>
      </p>

      <!-- Scheduled state -->
      <div
        class="ms-success"
        *ngIf="
          !manualScheduleLoading && manualScheduleResult && !isEditingSchedule
        "
      >
        <div class="ms-success-icon"><i class="pi pi-check-circle"></i></div>
        <h4>Interview Scheduled</h4>
        <p class="ms-success-sub">
          {{ scheduledDateLabel }} at {{ scheduledTimeLabel }}
        </p>

        <span
          class="ms-status-badge"
          [ngClass]="
            'status-' + (manualScheduleResult.status || '').toLowerCase()
          "
        >
          {{ manualScheduleResult.status }}
        </span>

        <div class="ms-detail-grid">
          <div class="ms-detail" *ngIf="manualScheduleResult.id">
            <span class="ms-detail-label">Schedule ID</span>
            <span class="ms-detail-value">#{{ manualScheduleResult.id }}</span>
          </div>

          <div class="ms-detail" *ngIf="manualScheduleResult.created_at">
            <span class="ms-detail-label">Created</span>
            <span class="ms-detail-value">
              {{
                manualScheduleResult.created_at | date: "dd MMM yyyy, shortTime"
              }}
            </span>
          </div>
        </div>

        <div
          class="ms-meeting-link"
          *ngIf="manualScheduleResult.teams_join_url"
        >
          <a [href]="manualScheduleResult.teams_join_url" target="_blank">
            <i class="pi pi-video"></i> Join Teams Meeting
          </a>
        </div>

        <p
          class="ms-meeting-pending"
          *ngIf="!manualScheduleResult.teams_join_url"
        >
          <i class="pi pi-info-circle"></i>
          Teams meeting link will be generated shortly.
        </p>

        <div
          class="ms-meeting-id"
          *ngIf="manualScheduleResult.teams_meeting_id"
        >
          <span class="ms-detail-label">Meeting ID</span>

          <code>{{ manualScheduleResult.teams_meeting_id }}</code>

          <button
            type="button"
            class="ms-copy-btn"
            (click)="copyMeetingId()"
            [attr.aria-label]="meetingIdCopied ? 'Copied' : 'Copy meeting ID'"
          >
            <i
              class="pi"
              [ngClass]="meetingIdCopied ? 'pi-check' : 'pi-copy'"
            ></i>
            {{ meetingIdCopied ? "Copied" : "Copy" }}
          </button>
        </div>
      </div>

      <!-- Form state -->
      <form
        [formGroup]="manualScheduleForm"
        class="modern-form"
        *ngIf="
          !manualScheduleLoading && (!manualScheduleResult || isEditingSchedule)
        "
      >
        <div class="form-section">
          <div class="form-row">
            <div class="form-field">
              <label for="ms_scheduled_date"
                >Scheduled Date <span style="color: red">*</span></label
              >
              <div class="input-container">
                <p-calendar
                  id="ms_scheduled_date"
                  formControlName="scheduled_date"
                  dateFormat="yy-mm-dd"
                  [showIcon]="true"
                  appendTo="body"
                  icon="pi pi-calendar"
                  class="input-field"
                ></p-calendar>
              </div>
              <small
                class="text-red-500"
                *ngIf="isManualScheduleInvalid('scheduled_date')"
              >
                Scheduled date is required.
              </small>
            </div>

            <div class="form-field">
              <label for="ms_start_time"
                >Start Time <span style="color: red">*</span></label
              >
              <div class="input-container">
                <p-calendar
                  id="ms_start_time"
                  formControlName="start_time"
                  [timeOnly]="true"
                  hourFormat="12"
                  [showIcon]="true"
                  appendTo="body"
                  icon="pi pi-clock"
                  class="input-field"
                ></p-calendar>
              </div>
              <small
                class="text-red-500"
                *ngIf="isManualScheduleInvalid('start_time')"
              >
                Start time is required.
              </small>
            </div>
          </div>
        </div>
      </form>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <!-- Create / edit form -->
    <div
      class="ms-footer"
      *ngIf="
        !manualScheduleLoading && (!manualScheduleResult || isEditingSchedule)
      "
    >
      <button
        pButton
        type="button"
        label="Cancel"
        class="p-button-text ms-btn-cancel"
        (click)="
          isEditingSchedule ? cancelEditSchedule() : closeManualScheduleDialog()
        "
      ></button>

      <button
        pButton
        type="button"
        [label]="isEditingSchedule ? 'Save Changes' : 'Schedule Interview'"
        [icon]="
          isManualScheduling
            ? 'pi pi-spin pi-spinner'
            : isEditingSchedule
              ? 'pi pi-check'
              : 'pi pi-calendar-plus'
        "
        [disabled]="isManualScheduling"
        class="ms-btn-submit"
        (click)="submitManualSchedule()"
      ></button>
    </div>

    <!-- Existing booking -->
    <div
      class="ms-footer"
      *ngIf="
        !manualScheduleLoading && manualScheduleResult && !isEditingSchedule
      "
    >
      <button
        pButton
        type="button"
        label="Reschedule"
        icon="pi pi-pencil"
        class="ms-btn-secondary"
        (click)="startEditSchedule()"
      ></button>

      <button
        pButton
        type="button"
        label="Done"
        icon="pi pi-check"
        class="ms-btn-submit"
        (click)="closeManualScheduleDialog()"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<div *ngIf="selectedCandidate">
  <!--Resume Detailed Analysis-->
  <p-dialog
    #evalDialog
    header="📋 Candidate Evaluation"
    [(visible)]="rankingDialogVisible"
    [modal]="true"
    [style]="{ width: '75vw', maxWidth: '900px' }"
    class="evaluation-dialog"
  >
    <div class="eval-container" #pdfContent>
      <!-- HEADER -->
      <div class="eval-header modern-shadow">
        <div class="left-info">
          <h2 class="candidate-name" style="color: white">
            {{ selectedCandidate?.name || "N/A" }}
          </h2>

          <p class="sub-info">
            <i class="pi pi-briefcase"></i>
            {{ selectedCandidate?.experience || 0 }}
            yrs &nbsp; • &nbsp;

            <i class="pi pi-map-marker"></i>

            <!-- Truncated location + tooltip -->
            <span
              class="truncate-location"
              pTooltip="{{ selectedCandidate?.location || 'N/A' }}"
              tooltipPosition="top"
            >
              {{ selectedCandidate?.location || "N/A" }}
            </span>
          </p>

          <!-- MATCH STATUS ROW -->
          <div class="match-status-row">
            <div class="match-item">
              <i class="pi pi-check-circle match-yes"></i>
              <span
                >{{ selectedCandidate?.skills?.matched?.length || 0 }} Skills
                Matched</span
              >
              <button
                type="button"
                class="eye-info-btn"
                (click)="
                  showInfo(
                    $event,
                    'How many required skills this candidate\'s resume mentions',
                    infoPanel
                  )
                "
                aria-label="More info"
              >
                <i class="pi pi-info-circle"></i>
              </button>
            </div>

            <div class="match-item">
              <i
                class="pi"
                [ngClass]="
                  selectedCandidate?.experience >= 3
                    ? 'pi-check-circle match-yes'
                    : 'pi-times-circle match-no'
                "
              ></i>

              <span>Experience Match</span>
            </div>
          </div>
          <!-- <p
          class="score-tag"
          [ngClass]="
            getFitClass(data?.candidate_evaluation?.fit_summary?.fit_category)
          "
        >
          {{ data?.candidate_evaluation?.fit_summary?.fit_category || "N/A" }}
        </p> -->
        </div>

        <!-- SCORE CIRCLE -->
        <div class="score-circle-box">
          <div class="score-circle">
            <svg width="110" height="110">
              <circle cx="55" cy="55" r="45" class="bg-ring"></circle>
              <circle
                cx="55"
                cy="55"
                r="45"
                class="progress-ring"
                [attr.stroke-dasharray]="scoreCircumference"
                [attr.stroke-dashoffset]="scoreDashoffset"
              ></circle>
            </svg>

            <div class="score-text">
              {{ selectedCandidate?.totalScore || 0 }}%
            </div>
          </div>
          <p class="score-subtext">
            out of 100
            <button
              type="button"
              class="eye-info-btn"
              (click)="
                showInfo(
                  $event,
                  'Overall resume match against this job\'s requirements',
                  infoPanel
                )
              "
              aria-label="More info"
            >
              <i class="pi pi-info-circle"></i>
            </button>
          </p>
        </div>

        <!-- DOWNLOAD BUTTON -->
        <!-- <button
        pButton
        class="export-top-btn p-button-rounded p-button-text header-download-btn"
        pTooltip="Download Evaluation PDF"
        tooltipPosition="left"
        (click)="downloadPdf()"
      >
        <i class="pi pi-download"></i>
      </button> -->
      </div>

      <!-- TABS -->
      <p-tabView class="modern-tabs">
        <!-- SUMMARY TAB -->
        <p-tabPanel header="Summary">
          <div class="card-grid">
            <div class="eval-card">
              <h3><i class="pi pi-thumbs-up success"></i> Strengths</h3>

              <!-- Show list if data exists -->
              <ul
                class="modern-list"
                *ngIf="
                  selectedCandidate?.strengths &&
                    selectedCandidate?.strengths.length > 0;
                  else noStrengths
                "
              >
                <li *ngFor="let s of selectedCandidate.strengths">
                  <i class="pi pi-check-circle success"></i> {{ s }}
                </li>
              </ul>

              <!-- No data -->
              <ng-template #noStrengths>
                <p class="no-data">No strengths found</p>
              </ng-template>
            </div>

            <div class="eval-card">
              <h3><i class="pi pi-flag warn"></i> Development Areas</h3>

              <!-- Show list if data exists -->
              <ul
                class="modern-list"
                *ngIf="
                  selectedCandidate?.weaknesses &&
                    selectedCandidate.weaknesses.length > 0;
                  else noDevAreas
                "
              >
                <li *ngFor="let d of selectedCandidate.weaknesses">
                  <i class="pi pi-exclamation-circle warn"></i> {{ d }}
                </li>
              </ul>

              <!-- No data -->
              <ng-template #noDevAreas>
                <p class="no-data">No development areas found</p>
              </ng-template>
            </div>
          </div>
        </p-tabPanel>

        <!-- SKILLS MATCH TAB -->
        <p-tabPanel header="Skills Match">
          <!-- Skills Summary -->
          <div
            class="skills-summary-box"
            *ngIf="selectedCandidate?.skills?.matched"
          >
            <p class="skills-summary-text">
              {{ selectedCandidate?.skills?.matched?.length || 0 }}
              of
              {{
                (selectedCandidate?.skills?.matched?.length || 0) +
                  (selectedCandidate?.skills?.missing?.length || 0)
              }}
              skills matched
            </p>
          </div>

          <div class="skills-grid">
            <!-- Matched Skills -->
            <div class="eval-card">
              <h3><i class="pi pi-check-circle success"></i> Matched Skills</h3>

              <ul
                class="modern-list"
                *ngIf="
                  selectedCandidate?.skills?.matched &&
                    selectedCandidate?.skills?.matched.length > 0;
                  else noMatchedSkills
                "
              >
                <li *ngFor="let skill of selectedCandidate?.skills?.matched">
                  <i class="pi pi-check success"></i>
                  {{ skill.name }}
                </li>
              </ul>

              <ng-template #noMatchedSkills>
                <p class="no-data">No matched skills found</p>
              </ng-template>
            </div>

            <!-- Missing Skills -->
            <div class="eval-card">
              <h3><i class="pi pi-times-circle danger"></i> Missing Skills</h3>

              <ul
                class="modern-list"
                *ngIf="
                  selectedCandidate?.skills?.missing &&
                    selectedCandidate?.skills?.missing.length > 0;
                  else noMissingSkills
                "
              >
                <li *ngFor="let skill of selectedCandidate?.skills?.missing">
                  <i class="pi pi-times danger"></i>
                  {{ skill }}
                </li>
              </ul>

              <ng-template #noMissingSkills>
                <p class="no-data">No missing skills found</p>
              </ng-template>
            </div>
          </div>
        </p-tabPanel>

        <!-- JD ALIGNMENT -->
        <p-tabPanel header="JD Alignment">
          <div class="eval-card">
            <h3>Matched JD Keywords</h3>

            <div
              *ngIf="
                selectedCandidate?.jdMatch?.matching_words?.length;
                else noKeywords
              "
            >
              <span
                class="role-pill"
                *ngFor="let word of selectedCandidate?.jdMatch?.matching_words"
              >
                {{ word }}
              </span>
            </div>

            <ng-template #noKeywords>
              <p class="no-data">No matching keywords found</p>
            </ng-template>

            <div class="mt-3">
              <strong>
                Total Matches:
                {{ selectedCandidate?.jdMatch?.matching_word_count || 0 }}
              </strong>
            </div>
          </div>
        </p-tabPanel>

        <!-- EXPERIENCE TAB -->
        <p-tabPanel header="Experience">
          <div class="eval-card exp-card">
            <div class="exp-row">
              <div class="exp-box">
                <i class="pi pi-user exp-icon blue"></i>

                <div class="exp-info">
                  <strong>Total Experience</strong>

                  <p>{{ selectedCandidate?.experience || 0 }} Years</p>
                </div>
              </div>

              <div class="exp-box">
                <i class="pi pi-briefcase exp-icon green"></i>

                <div class="exp-info">
                  <strong>Employment Records</strong>

                  <p>
                    {{ selectedCandidate?.employment?.length || 0 }}
                  </p>
                </div>
              </div>
            </div>

            <h4 class="roles-title">
              <i class="pi pi-briefcase"></i>
              Previous Roles
            </h4>

            <div
              *ngIf="selectedCandidate?.employment?.length; else noEmployment"
            >
              <div
                class="eval-card mt-2"
                *ngFor="let job of selectedCandidate?.employment"
              >
                <h4>{{ job.designation }}</h4>

                <p>
                  <strong>{{ job.organization }}</strong>
                </p>

                <p>
                  {{ job.location }}
                </p>

                <p>{{ job.from }} - {{ job.to }}</p>

                <p>
                  {{ job.profile }}
                </p>
              </div>
            </div>

            <ng-template #noEmployment>
              <p class="no-data">No employment history found</p>
            </ng-template>
          </div>
        </p-tabPanel>

        <!-- INSIGHTS TAB -->
        <p-tabPanel header="Candidate Insights">
          <div class="card-grid">
            <div class="eval-card">
              <h3>
                <i class="pi pi-book success"></i>
                Education
              </h3>

              <div
                *ngIf="selectedCandidate?.education?.length; else noEducation"
              >
                <div
                  *ngFor="let edu of selectedCandidate?.education"
                  class="mb-3"
                >
                  <p>
                    <strong>{{ edu.type }}</strong>
                  </p>

                  <p>{{ edu.institution }}</p>

                  <p>
                    Marks:
                    {{ edu.marks || "--" }}
                  </p>

                  <p>
                    Year:
                    {{ edu.year }}
                  </p>
                </div>
              </div>

              <ng-template #noEducation>
                <p class="no-data">No education found</p>
              </ng-template>
            </div>

            <div class="eval-card">
              <h3>
                <i class="pi pi-verified success"></i>
                Certifications
              </h3>

              <ul
                class="modern-list"
                *ngIf="selectedCandidate?.certifications?.length; else noCerts"
              >
                <li *ngFor="let cert of selectedCandidate?.certifications">
                  <i class="pi pi-check-circle success"></i>

                  {{ cert.name }}

                  <span *ngIf="cert.issuing_org">
                    ({{ cert.issuing_org }})
                  </span>
                </li>
              </ul>

              <ng-template #noCerts>
                <p class="no-data">No certifications found</p>
              </ng-template>
            </div>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>

    <p-footer> </p-footer>
  </p-dialog>
</div>

<p-dialog
  [(visible)]="timelineDialogVisible"
  [modal]="true"
  [closable]="true"
  [showHeader]="false"
  [style]="{ width: '480px', 'max-width': '92vw' }"
  class="modern-dialog timeline-dialog"
  (onHide)="closeTimelineDialog()"
>
  <ng-template pTemplate="content">
    <div class="timeline-loading" *ngIf="timelineLoading">
      <i class="pi pi-spin pi-spinner"></i>
      <p>Loading timeline…</p>
    </div>

    <div class="tl" *ngIf="!timelineLoading && timelineData">
      <!-- Custom banner header with progress ring -->
      <div class="tl-banner">
        <button class="tl-close" (click)="closeTimelineDialog()">
          <i class="pi pi-times"></i>
        </button>

        <div class="tl-ring">
          <svg viewBox="0 0 60 60">...</svg>
          <span class="tl-ring-label">{{ timelineProgressPercent }}%</span>
        </div>
        <button
          type="button"
          class="eye-info-btn"
          (click)="
            showInfo(
              $event,
              'Share of pipeline steps completed so far',
              infoPanel
            )
          "
          aria-label="More info"
          style="margin-top: 4px"
        >
          <i class="pi pi-info-circle"></i>
        </button>

        <div class="tl-banner-text">
          <span class="tl-eyebrow">Candidate Journey</span>
          <span class="tl-email">{{ timelineData.candidate }}</span>
          <span class="tl-substep">
            {{ timelineCompletedCount }} of {{ timelineTotalCount }} steps
            cleared
          </span>
        </div>

        <div class="tl-score" *ngIf="timelineData.exam_score !== null">
          <span class="tl-score-label">Exam</span>
          <span class="tl-score-value">{{ timelineData.exam_score }}</span>
        </div>
      </div>

      <!-- Steps -->
      <ol class="tl-steps">
        <li
          class="tl-step"
          *ngFor="let step of timelineData.timeline; let i = index"
          [ngClass]="getStepStatus(step)"
          [style.animation-delay.ms]="i * 45"
        >
          <span class="tl-node">
            <i
              class="pi"
              [ngClass]="{
                'pi-check': getStepStatus(step) === 'done',
                'pi-times': getStepStatus(step) === 'pending',
                'pi-minus': getStepStatus(step) === 'info',
              }"
            ></i>
          </span>

          <div class="tl-content">
            <div class="tl-content-top">
              <span class="tl-step-no">{{ step.step }}</span>
              <span class="tl-label">{{ step.label }}</span>
            </div>

            <span class="tl-meta tl-meta--time" *ngIf="step.sent_at">
              {{ step.sent_at | date: "MMM d, y · h:mm a" }}
            </span>

            <span
              class="tl-meta tl-meta--muted"
              *ngIf="!step.sent_at && step.value === null"
            >
              Not yet reached
            </span>

            <span
              class="tl-pill"
              *ngIf="
                step.value !== null &&
                step.value !== true &&
                step.value !== false
              "
            >
              {{ step.value }}
            </span>
          </div>
        </li>
      </ol>
    </div>
  </ng-template>
</p-dialog>

<!-- EXAM & ROUND STATUS DIALOG -->
<p-dialog
  [(visible)]="examRoundDialogVisible"
  [modal]="true"
  [closable]="true"
  [showHeader]="false"
  [style]="{ width: '520px', 'max-width': '94vw' }"
  class="modern-dialog exam-round-dialog"
  (onHide)="closeExamRoundDialog()"
>
  <ng-template pTemplate="content">
    <div class="tl-banner er-banner">
      <button class="tl-close" (click)="closeExamRoundDialog()">
        <i class="pi pi-times"></i>
      </button>

      <div class="tl-banner-text">
        <span class="tl-eyebrow">Exam & Round Status</span>
        <span class="tl-email">{{ examRoundCandidate?.name || "--" }}</span>
        <span class="tl-substep">
          {{ examRoundCandidate?.roundProgress?.length || 0 }} round{{
            examRoundCandidate?.roundProgress?.length === 1 ? "" : "s"
          }}
          recorded
        </span>
      </div>
    </div>

    <div class="hr-body">
      <!-- Empty state: candidate hasn't attempted anything yet -->
      <div class="hr-empty" *ngIf="!examRoundCandidate?.roundProgress?.length">
        <i class="pi pi-inbox"></i>
        <p>This candidate hasn't attempted any exam or round yet.</p>
      </div>

      <!-- Round-by-round breakdown -->
      <div class="hr-rounds" *ngIf="examRoundCandidate?.roundProgress?.length">
        <div
          class="hr-round-card"
          *ngFor="let round of examRoundCandidate.roundProgress"
        >
          <div class="hr-round-top">
            <span class="hr-round-no">Round {{ round.round_number }}</span>
            <span
              class="type-badge"
              [ngClass]="getReportRoundBadgeClass(round.round_type)"
              >{{ round.exam_title || formatRoundType(round.round_type) }}</span
            >
          </div>

          <div class="hr-round-status-row">
            <span
              class="hr-status-pill"
              [ngClass]="getReportStatusClass(round.status)"
              >{{ getReportStatusLabel(round.status) }}</span
            >

            <span
              class="hr-round-score"
              *ngIf="round.score !== null && round.score !== undefined"
              >Score: <strong>{{ round.score }}</strong>
            </span>
          </div>

          <div class="hr-round-feedback" *ngIf="round.feedback">
            {{ formatFeedback(round.feedback) }}
          </div>

          <div class="hr-round-meta-row" *ngIf="round.completed_at">
            <span>
              <i class="pi pi-calendar"></i>
              {{ round.completed_at | date: "MMM d, y · h:mm a" }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</p-dialog>

<!-- BULK UPLOAD DIALOG -->
<p-dialog
  [(visible)]="uploadDialogVisible"
  [modal]="true"
  [closable]="true"
  [showHeader]="false"
  [style]="{ width: '480px', 'max-width': '92vw' }"
  styleClass="upload-dialog-modern"
  class="upload-dialog-modern"
>
  <ng-template pTemplate="content">
    <div class="upload-container">
      <!-- HEADER -->
      <div class="upload-dialog-header">
        <div class="upload-dialog-heading">
          <span class="upload-dialog-icon">
            <i class="pi pi-cloud-upload"></i>
          </span>
          <div>
            <h4>Bulk Upload Resumes</h4>
            <p>Attach one or more candidate resumes to this job</p>
          </div>
        </div>

        <button
          type="button"
          class="upload-dialog-close"
          (click)="closeUploadDialog()"
          aria-label="Close"
        >
          <i class="pi pi-times"></i>
        </button>
      </div>

      <!-- DROP AREA -->
      <div class="drop-zone" (click)="fileInput.click()">
        <span class="upload-icon-badge">
          <i class="pi pi-cloud-upload upload-icon"></i>
        </span>
        <p class="drop-zone-title" *ngIf="!selectedFiles.length">
          Click to upload or drag files here
        </p>
        <p class="drop-zone-hint">PDF, DOC or DOCX — up to 2MB each</p>

        <input
          #fileInput
          type="file"
          multiple
          hidden
          accept=".pdf,.doc,.docx"
          (change)="onFileSelect($event)"
        />
      </div>

      <!-- FILE PREVIEW LIST -->
      <div *ngIf="selectedFiles.length" class="selected-files-list mt-2">
        <div
          *ngFor="let file of selectedFiles; let i = index"
          class="file-preview mb-2"
        >
          <div class="file-info">
            <span class="file-info-icon"><i class="pi pi-file"></i></span>
            <span class="file-info-name" [title]="file.name">{{
              file.name
            }}</span>
          </div>

          <button
            class="remove-btn"
            pTooltip="Remove"
            tooltipPosition="top"
            (click)="removeFile(i)"
          >
            <i class="pi pi-times"></i>
          </button>
        </div>
      </div>

      <!-- ERROR -->
      <div class="upload-error" *ngIf="fileError">
        <i class="pi pi-exclamation-circle"></i>
        <span>{{ fileError }}</span>
      </div>

      <!-- ACTIONS -->
      <div class="upload-actions mt-3">
        <button class="btn" (click)="closeUploadDialog()">Cancel</button>

        <button
          class="btn primary"
          [disabled]="!selectedFiles.length || uploading"
          (click)="uploadResume()"
        >
          <i class="pi pi-spin pi-spinner" *ngIf="uploading"></i>
          <span *ngIf="!uploading"
            >Upload
            {{
              selectedFiles.length ? "(" + selectedFiles.length + ")" : ""
            }}</span
          >
          <span *ngIf="uploading">Uploading...</span>
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<!-- ============================ WHY THIS CV FAILED ============================ -->
<p-dialog
  [(visible)]="failureDialogVisible"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [showHeader]="false"
  [style]="{ width: '420px', 'max-width': '94vw' }"
  styleClass="vjd-fail-dialog"
>
  <div class="vjd-fail-box" *ngIf="failureDialogCandidate as fc">
    <button type="button" class="vjd-fail-box__close" (click)="failureDialogVisible = false" aria-label="Close">
      <i class="pi pi-times"></i>
    </button>

    <span class="vjd-fail-box__icon"><i class="pi pi-exclamation-triangle"></i></span>
    <span class="vjd-fail-box__eyebrow">Why this CV failed</span>
    <h3>{{ fc.failure?.title }}</h3>
    <p class="vjd-fail-box__file" *ngIf="fc.name || fc.fileName">
      <i class="pi pi-file"></i> {{ fc.name || fc.fileName }}
    </p>

    <p class="vjd-fail-box__msg">{{ fc.failure?.message }}</p>

    <div class="vjd-fail-box__fix">
      <i class="pi pi-wrench"></i>
      <div>
        <strong>How to fix it</strong>
        <span>{{ fc.failure?.fix }}</span>
      </div>
    </div>

    <div class="vjd-fail-box__actions">
      <button type="button" class="vjd-fail-box__btn" *ngIf="fc.resumeUrl" (click)="viewResume(fc)">
        <i class="pi pi-eye"></i> View CV
      </button>
      <button type="button" class="vjd-fail-box__btn is-primary" (click)="failureDialogVisible = false">
        Got it
      </button>
    </div>
  </div>
</p-dialog>
